import API from "@/API";

export default {
  namespaced: true,
  state: {},
  actions: {
    async sendEmailVerification({}, accountID) {
      try {
        await API.Account.sendEmailVerification(accountID);
      } catch (e) {
        throw e;
      }
    },

    async searchByName({}, { textSearch, filter, includes }) {
      try {
        return await API.Account.searchByName(textSearch, filter, includes);
      } catch (e) {
        throw e;
      }
    },

    async verifyEmail({}, accountID) {
      try {
        await API.Account.verifyEmail(accountID);
      } catch (e) {
        throw e;
      }
    },

    async update({}, account) {
      try {
        await API.Account.update(account);
      } catch (e) {
        throw e;
      }
    },

    async changeStatus({}, payload) {
      try {
        await API.Account.changeStatus(payload.accountID, payload.action);
      } catch (e) {
        throw e;
      }
    }
  },
  mutations: {},
  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/account.js